import type { StepConfigFor } from '../getStepConfig.types.ts';

export const UploadHealthcareSummaryStepConfig = {
  title: ({ isHealthcareProvider }) =>
    isHealthcareProvider ? "Patient's Health Summary" : 'Upload Your Health Summary',

  statuses: {
    NOT_STARTED: {
      label: 'Not Uploaded',
      cta: 'Upload Now',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient is tasked with uploading their health summary'
          : 'Please upload your health summary',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider ? 'Patient needs to upload their health summary' : 'Please upload your health summary',
    },

    PENDING: {
      label: 'Under Review',
      cta: 'Resubmit',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has submitted their health summary. We need to review it and update the status'
          : 'You have submitted your health summary. We are reviewing it and will update you shortly',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has submitted their health summary. We need to review it and update the status'
          : 'Your health summary is being reviewed. We will update you shortly',
    },

    COMPLETED: {
      label: 'Approved',
      cta: 'View',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has successfully uploaded their health summary'
          : 'You have successfully uploaded your health summary',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has successfully uploaded their health summary and we have approved it'
          : 'You have successfully uploaded your health summary',
    },

    ERROR: {
      label: 'Needs Resubmission',
      cta: 'Resubmit Now',
      description: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The uploaded file is incorrect, missing or has missing required information. The patient will need to resubmit it'
          : 'There was an issue with your health summary. Please resubmit it',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The uploaded file is incorrect, missing or has missing required information. The patient will need to resubmit it'
          : 'There was an issue with your health summary. Please resubmit it',
    },
  },
} satisfies StepConfigFor<'UPLOAD_HEALTHCARE_SUMMARY'>;
